module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_03 (1).e7a617fd.png";